import React, { useEffect, useState } from "react";
import { FormControl, FormLabel, Select, Spinner } from "@chakra-ui/react";

const AccountSelectById = ({
  label = "Select Account",
  selectedAccountId,
  onChange,
  type,
  size = "md",
  height,
}) => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAccounts = async () => {
      setLoading(true);
      try {
        const url = new URL("https://ledgers.poc.mrc.ai/api/accounts");
        if (type) url.searchParams.set("type", type);

        const res = await fetch(url.toString());
        const json = await res.json();

        if (Array.isArray(json)) {
          const sorted = [...json].sort((a, b) =>
            (a.name || "").localeCompare(b.name || "")
          );
          setAccounts(sorted);
        } else {
          setAccounts([]);
        }
      } catch (err) {
        console.error("Failed to fetch accounts:", err);
        setAccounts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAccounts();
  }, [type]);

  const handleSelect = (id) => {
    const selected = accounts.find((a) => a._id === id);
    onChange(selected ? { id: selected._id, name: selected.name } : null);
  };

  return (
    <FormControl>
      {label && <FormLabel>{label}</FormLabel>}
      {loading ? (
        <Spinner />
      ) : (
        <Select
          placeholder="Select account..."
          value={selectedAccountId || ""}
          onChange={(e) => handleSelect(e.target.value)}
          size={size}
          height={height}
        >
          {accounts.length > 0 ? (
            accounts.map((account) => (
              <option key={account._id} value={account._id}>
                {account.name}
              </option>
            ))
          ) : (
            <option disabled>No accounts available</option>
          )}
        </Select>
      )}
    </FormControl>
  );
};

export default AccountSelectById;
